<template>
    <div>
        <h2 class="font-weight-regular black--text">
            Landing page details
        </h2>
        <v-row>
            <v-col cols="12">
                Title:
                <div class="black--text">
                    {{ value.splash.title }}
                </div>
            </v-col>
        </v-row>
        <v-divider />
        <v-row>
            <v-col cols="12">
                Body text:
                <div class="black--text"
                     v-html="value.splash.bodyText"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: 'LandingPageDetails',
        props: {
            value: {
                type: Object,
                default: () => {
                    return {
                        splash: {
                            title: '',
                            bodyText: '',
                        },
                    };
                }
            }
        }
    };
</script>

<style scoped>

</style>